import SignupComponent from "../component/signup/signup";

function SignupPage() {
  return <SignupComponent />;
}
export default SignupPage;
